<template>
    <ds-popover
        :is-open="showTooltip"
        position="right"
        position-fixed
    >
        <template #reference>
            <ds-icon-button
                name="help-circle"
                class="tooltip-button"
                title=""
                @click="showTooltip = !showTooltip"
                @mouseover="showTooltip = true"
                @mouseleave="showTooltip = false"
            />
        </template>

        <template #default>
            <div class="tooltip-message">
                Contacts with phone numbers that are opted out, duplicate, or invalid will be skipped
            </div>
        </template>
    </ds-popover>
</template>

<script>
export default {
    data() {
        return { showTooltip: false };
    },
};
</script>

<style lang="scss" scoped>
.tooltip-button {
    margin: $spacing-050 $spacing-100 0;
    align-self: flex-start;

    --icon-color: #{$color-gray-800};
    --icon-size: 1rem;
}

.tooltip-message {
    padding: $spacing-100;
    line-height: $line-height-lg;
    font-size: $font-size-md;
}
</style>
